import React from "react";
import { Input } from "../../../../../../../../../../../../components";
import { FORM_KEYS } from "../../../../../../../../../../constants";
/**
 * @desc Input sku for product details form.
 */
export const InputProductSku = ({ product }) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: `${product.sku}-form-product-sku-error`,
  };

  const inputProps = {
    type: "text",
    id: `${product.sku}-input-product-sku`,
    className: "form-control",
    "aria-describedby": errorProps.id,
    autoComplete: "off",
    disabled: true,
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "SKU",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.PRODUCT_SKU,
  };

  return <Input {...parentProps} />;
};
